@if (results.length > 0) {
    <div class="grid">
        @for (result of results; track result) {
            <app-plant-card
                [imageUrl]="result.images && result.images[0] ? result.images[0].url : ''"
                [confidenceScore]="result.score"
                [alt]="result.scientificName"
                [commonNames]="result.commonNames"
                [scientificName]="result.scientificName"
                (click)="onClick(result)">
            </app-plant-card>
        }
    </div>
} @else {
    <p>No results found.</p>
}
